module.exports = __webpack_public_path__ + "img/r6.880f1526.jpg";